import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';

import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { NgOtpInputModule } from 'ng-otp-input';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TabsModule } from 'primeng/tabs';
import { DatePicker } from 'primeng/datepicker';
import { ChartModule } from 'primeng/chart';



@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule,
    ButtonModule,
    DialogModule,
    MultiSelectModule,
    InputTextModule,
    ToggleSwitchModule,
    ToggleButtonModule,
    SelectModule,
    NgOtpInputModule,
    TabsModule,
    DatePicker,
    ChartModule
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule,
    ButtonModule,
    DialogModule,
    MultiSelectModule,
    InputTextModule,
    ToggleSwitchModule,
    ToggleButtonModule,
    SelectModule,
    NgOtpInputModule,
    TabsModule,
    DatePicker,
    ChartModule
  ]
})
export class PrimeNgModule {}
